import { Thermostat } from '@mui/icons-material'
import { Appliance, ApplianceConfigTemperature, ApplianceSubtype, ApplianceType } from './Appliance'
import { PortControl } from '../ports/PortControl'
import { PortConfig } from '../../types/ports'
import { Port } from '../../types/models'
import { getWidget } from '../widgets'
import { TemperatureStatWidget } from '../widgets/TemperatureStatWidget'

export class TemperatureAppliance extends Appliance<{}, ApplianceConfigTemperature> {

  get Icon() {
    return Thermostat
  }

  getSubtypes(): Record<string, string> {
    return {
      [this.app.t('DS18B20 One-Wire digital sensor')]: 'TEMPERATURE_DRIVER_DS18B20',
      // [this.app.t('NTC thermistor')]: 'TEMPERATURE_DRIVER_NTC',
      // [this.app.t('From other appliance')]: 'TEMPERATURE_DRIVER_OTHERPORT',
      [this.app.t('CPU Temperature')]: 'TEMPERATURE_DRIVER_CPU',
    }
  }

  isSuitable(ctrl: PortControl<Port, PortConfig>, subtype: ApplianceSubtype): boolean {
    if (ctrl.port.type !== 'TEMPERATURE') return false
    if (subtype === 'TEMPERATURE_DRIVER_CPU') {
      return ctrl.port.port_number === '104/0'
    } else {
      return ctrl.port.port_number !== '104/0'
    }
  }

  initializeConfig(portControl: PortControl<Port, PortConfig>, type: ApplianceType, subtype: ApplianceSubtype) {
    portControl.setConfig('driver', subtype)
  }

  getDefaultWidgets(): [TemperatureStatWidget] {
    return [
      getWidget({
        name: '',
        type: 'TEMPERATURE_STAT',
        appliances: [this],
        config: {}
      }, this.control, this.app) as TemperatureStatWidget,
    ]
  }

  filterSuitablePorts(ports: PortControl<Port, PortConfig>[]): PortControl<Port, PortConfig>[] {
    return this.autoAllocate(ports)
  }
}
